module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/michal-paszkowski-afaeb84952615f66c4a64eab51ace5b7.png";